<template>
  <section class="form-section">
    <div
      class="flex row"
      v-if="isShowList"
    >
      <div class="title-page-form">Solicitações</div>
      <div class="div-requests col-12 row flex">
        <CardSolicitationOs
          v-for="(item, index) in contract.solicitations"
          :check="item.isFilled"
          :os-number="item.osNumber"
          :type-os="item.typeOS"
          :key="item.onject_id"
          :title="
            `Concluir atividade - ${typeOs.name_type}`.toLocaleUpperCase()
          "
          @edit="handleShowEditSolicitation(item)"
          @removeCard="() => updateSolicitation(item.object_id)"
        />
      </div>
      <div class="col-12 row flex justify-end q-mt-md">
        <q-btn
          unelevated
          text-color="red-9"
          size="md"
          icon="add"
          label="Nova solicitação"
          @click="addNewSchemaRequest"
        />
      </div>
    </div>
    <SolicitationForm
      v-else
      :itemOsContract="itemOsContract"
      :city="contract.city"
      :optionsItens="optionsItens"
      :typeOs="typeOs.os_type"
      @clearSchemaRequest="() => {}"
      @saveSchemaRequest="(requestData) => saveSchemaRequest(requestData)"
      @removeEdit="() => showEditSolicitation()"
    />
  </section>
</template>

<script>
  import CardSolicitationOs from "@/components/cards/CardSolicitationOs.vue";
import { onMounted, ref } from "vue";

  import generateUUIDv4 from "@/utils/generetaUUID.js";
import { reactive } from "vue";
import SolicitationForm from "./Forms/SolicitationForm.vue";

  export default {
    name: "SolicitationList",
    props: {
      contract: Object,
      optionsItens: Object,
      typeOs: Object,
    },
    components: {
      SolicitationForm,
      CardSolicitationOs,
    },
    emits: ["disabledtabButton"],

    setup(props, { emit }) {
      let itemOsContract = reactive({
        data: {},
      });

      let schemeSolicitation = {
        object_id: generateUUIDv4(),
        osNumber: "",
        typeOS: null,
        observation: "",
        isFilled: false,
      };

      let isShowList = ref(true);

      function addNewSolicitation() {
        props.contract.solicitations.push(schemeSolicitation);
      }

      function updateSolicitation(requestData) {
        let index = props.contract.solicitations.findIndex((obj) => {
          return obj.object_id == requestData.object_id;
        });

        props.contract.solicitations[index] = requestData;
      }

      function handleShowEditSolicitation(item) {
        itemOsContract.data = item;
        isShowList.value = false;
        emit("disabledtabButton", false);
      }

      function showEditSolicitation() {
        emit("disabledtabButton", true);
        isShowList.value = true;
      }

      function saveSchemaRequest(requestData) {
        emit("disabledtabButton", true);
        updateSolicitation(requestData);
        isShowList.value = true;
        schemeSolicitation.isFilled = true;
      }

      async function validateForm() {
        return true;
      }

      function addNewSchemaRequest() {
        let schemaRequest = {
          object_id: generateUUIDv4(),
          osNumber: "",
          typeOS: null,
          observation: "",
          isFilled: false,
        };

        props.contract.solicitations.push(schemaRequest);
      }

      onMounted(() => {
        addNewSolicitation();
      });

      return {
        schemeSolicitation,
        isShowList,
        addNewSolicitation,
        updateSolicitation,
        handleShowEditSolicitation,
        showEditSolicitation,
        saveSchemaRequest,
        validateForm,
        addNewSchemaRequest,
        itemOsContract,
      };
    },
  };
</script>

<style lang="scss" scoped>
  .form-section {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
</style>
